const useragent = window.navigator ? navigator.userAgent.toLowerCase() : '';
export const isIE11 = () => useragent.includes('trident/');